import {BehaviorSubject, Subject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  showLoader: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showRefreshButton: BehaviorSubject<boolean> = new BehaviorSubject(false);

  toast: Subject<{
    title: string;
    message?: string;
    type: 'info' | 'success' | 'warning' | 'error' | 'custom'
  }> = new Subject();

  cardTypeCheck: Subject<string> = new Subject();
  
  showToast(type: 'info' | 'success' | 'warning' | 'error' | 'custom', title: string, message: string = '') {
    if (title || message &&
      (
        !(title || '').toLowerCase().includes('failed') &&
        !(message || '').toLowerCase().includes('failed')
      )
    ) {
      this.toast.next({message, type, title});
    }
  }

  // Start Loader
  showLoading() {
    this.showLoader.next(true);
  }

  // Stop Loader
  dismissLoading() {
    this.showLoader.next(false);
  }

  checkCardType(cardType?: string) {
    if (cardType) {
      this.cardTypeCheck.next(cardType);
    }
  }

  /**
   * Function to perform a deep copy on an object
   * @param obj - The object to be deeply copied
   * @returns A new object that is a deep copy of the input object
   */
  createDeepCopy(obj: any): any {
    if (!obj) {
      return null;
    }
    return JSON.parse(JSON.stringify(obj));
  }

  /**
   * Method to format input string
   * @param input String to format
   * @returns It returns a formatted string as capitalized first letter
   */
  toTitleCase(input?: string): string {
    if (!input) {
      return '';
    }
    return input
      .replace(/_/g, ' ') // Replace underscores with spaces
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  trimString(str: string, maxLength = 30, fallback = '-') {
    if (!str) {
      return fallback;
    }

    if (str.length > maxLength) {
      return str.slice(0, maxLength) + '...';
    }

    return str;
  }

  async getCurrencies() {
    try {
      const res = await fetch('/assets/jsons/currency.json');
      const json = await res.json();

      const list = (Object.keys(json) || []).map((key) => ({
        code: key,
        icon: json[key]
      }));

      const data = list.map((item: { code: string, icon: string }) => ({
        title: item.code,
        value: item.code,
        disabled: false,
        path: ''
      }));

      return data;
    } catch (error) {
      console.error('Error fetching currencies:', error);
      return [];
    }
  }
  downloadCSV(reportData: any[][], fileName: string = 'import-report.csv'): void {
    if (reportData?.length > 1) {
      const csvRows = reportData.map((row) =>
        row.map((field) =>
          typeof field === 'string' && (field.includes(',') || field.includes('"'))
            ? `"${field.replace(/"/g, '""')}"`
            : field
        ).join(',')
      );
      const csvData = csvRows.join('\n');
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
